import { AbstractControl, FormGroup } from '@angular/forms';
import { Injectable, inject } from '@angular/core';

import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { WtFocusService } from './wt-focus.service';

export enum ValidationState {
  None = 'none',
  Error = 'error',
  Success = 'success',
}

@Injectable({ providedIn: 'root' })
export class FormsService {
  private focusService = inject(WtFocusService);

  public getFormValidator(form: FormGroup) {
    return new FormValidator(form, this.focusService);
  }
}

export class FormValidator {
  public submitted$ = new BehaviorSubject(false);

  private observables: { [s: string]: Observable<ValidationState> } = {};

  constructor(
    public form: FormGroup,
    private focusService: WtFocusService
  ) {}

  public setSubmitted(): void {
    this.submitted$.next(true);
    this.markAllTouched(this.form);
    this.focusFirstInvalidFormElement(this.form);
  }

  public getControlStatus(controlName: string): Observable<ValidationState> {
    // eslint-disable-next-line sonarjs/different-types-comparison
    if (this.observables[controlName] === undefined) {
      this.observables[controlName] = this.bloog(controlName);
    }

    return this.observables[controlName];
  }

  private bloog(controlName: string): Observable<ValidationState> {
    const statusChanges = this.form.controls[controlName].statusChanges.pipe(startWith('VALID'));

    const submittedChanges = this.submitted$;

    return combineLatest([statusChanges, submittedChanges]).pipe(
      map(([controlStatus, submitted]) => {
        // eslint-disable-next-line sonarjs/no-selector-parameter
        if (controlStatus === 'INVALID' && submitted) {
          return ValidationState.Error;
        } else if (controlStatus === 'VALID' && submitted) {
          return ValidationState.Success;
        } else {
          return ValidationState.None;
        }
      })
    );
  }

  private markAllTouched(control: FormGroup | AbstractControl): void {
    control.markAsTouched({ onlySelf: true });

    if (control instanceof FormGroup) {
      for (const inner in control.controls) {
        const foo = control.get(inner);

        if (foo) {
          this.markAllTouched(foo);
        }
      }
    } else {
      control.updateValueAndValidity();
    }
  }

  private focusFirstInvalidFormElement(form: FormGroup): void {
    const keys = Object.keys(form.controls);

    for (let i = 0; i < keys.length; i++) {
      if (form.controls[keys[i]].invalid) {
        this.focusService.focusFormControl(form.controls[keys[i]]);
        return;
      }
    }
  }
}
